module.exports = __webpack_public_path__ + "img/icons B_7.429e5b8b.svg";